import posthog from 'posthog-js';

import { env, isProduction } from '@/lib/env';

if (!isProduction) {
  console.log('PostHog is only available in production mode');
} else if (!env.NEXT_PUBLIC_POSTHOG_TOKEN) {
  console.warn('PostHog token not configured');
} else {
  posthog.init(env.NEXT_PUBLIC_POSTHOG_TOKEN, {
    api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
    defaults: '2026-01-30',
    before_send: (event) => {
      const email = posthog.get_property('$email') as string | undefined;
      if (email?.toLowerCase().endsWith('@getcreatr.com')) return null;
      return event;
    },
    session_recording: {
      recordCrossOriginIframes: true,
    },
  });
}
